import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=1269d5c0&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=1269d5c0&prod&lang=scss&scoped=true"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=1269d5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269d5c0",
  null
  
)

export default component.exports